import React from 'react';
import { Constrain, Divider, Stack } from '@moda/om';
import { SiteFooterMailingList } from '../SiteFooterMailingList';
import { SiteFooterBasement } from '../SiteFooterBasement';
import { SiteFooterLinks } from '../SiteFooterLinks';

import './SiteFooterDesktop.scss';

export const SiteFooterDesktop = () => (
  <Constrain className="SiteFooterDesktop">
    <Stack space={5}>
      <SiteFooterMailingList className="SiteFooterDesktop__mailing-list" />
      <SiteFooterLinks />
      <Divider className="SiteFooterDesktop__divider" />
      <SiteFooterBasement />
    </Stack>
  </Constrain>
);
